import { PiSpinnerGapBold } from "react-icons/pi";

export default function Spinner() {
  return (
    <div className="w-full flex justify-center">
      <PiSpinnerGapBold className="text-primary animate-spin text-4xl" />
    </div>
  );
}
